import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Env from '@/lib/Env';

window.Bugsnag = Bugsnag;

export const bugsnagInit = (options = {}) => {
    const enabledReleaseStages = Env.hasFeature(Env.features.BUGSNAG) ? [process.env.NODE_ENV] : [];

    if (enabledReleaseStages.length) {
        Env.log.info('Initializing bugsnag');
    }

    Bugsnag.start({
        enabledReleaseStages,
        releaseStage: process.env.NODE_ENV,
        ...options,
        plugins: [new BugsnagPluginVue()],
    });

    const bugsnagVue = Bugsnag.getPlugin('vue');
    bugsnagVue.installVueErrorHandler(Vue);

    return Bugsnag;
};

export default Bugsnag;
